import { withIcon } from "../Icon"

export const IconBurgerMenu = withIcon(
  '<path fill="currentColor" d="M3 4h18v1.5H3zM3 11h18v1.5H3zM3 18h18v1.5H3z"/>',
)
